export const locale = {
    lang: "es",
    data: {
        TOOLBAR: {
            Help: "Abrir manual de usuario",
            BrowserNotificationsTitle: "Notificaciones del navegador",
            BrowserNotificationsPromptBody:
                "Si continúas, este navegador quedará registrado para tu usuario y recibirás notificaciones del navegador de Emma en toda la app.",
            BrowserNotificationsEnabledBody:
                "Las notificaciones del navegador ya están activadas para tu usuario. Puedes gestionar el proyecto actual desde aquí.",
            BrowserNotificationsPermissionDenied:
                "Las notificaciones del navegador están desactivadas en este navegador. Vuelve a activarlas desde la configuración del sitio para que Emma pueda enviarte alertas aquí.",
            BrowserNotificationsCurrentProject: "Proyecto actual",
            BrowserNotificationsProjectToggle: "Recibir notificaciones en este proyecto",
            BrowserNotificationsProjectStatusEnabled: "Notificaciones activadas en este proyecto",
            BrowserNotificationsProjectStatusMuted: "Notificaciones silenciadas en este proyecto",
            BrowserNotificationsProjectEnabled: "Notificaciones del navegador activadas para este proyecto.",
            BrowserNotificationsProjectMuted: "Notificaciones del navegador silenciadas para este proyecto.",
            BrowserNotificationsEnableAction: "Activar notificaciones",
            BrowserNotificationsSkip: "Ahora no",
            BrowserNotificationsNotConfigured: "Las notificaciones del navegador no están configuradas en este entorno.",
            BrowserNotificationsUnsupported: "Este navegador no soporta notificaciones push.",
            BrowserNotificationsEnabled: "Notificaciones del navegador activadas.",
            BrowserNotificationsError: "No se pudo actualizar la preferencia de notificaciones del navegador.",
            BrowserNotificationHeadlineAlarm: "Alarma crítica",
            BrowserNotificationHeadlineWarning: "Alarma de advertencia",
            BrowserNotificationHeadlineSuccess: "Alarma desactivada",
            BrowserNotificationHeadlineInfo: "Notificación",
            BrowserNotificationFieldAlarm: "Alarma",
            BrowserNotificationFieldProject: "Proyecto",
            BrowserNotificationFieldDevice: "Dispositivo",
        },
    },
};
